import React from 'react';

interface DialogFooterProps {
  children?: React.ReactNode;
  centered?: boolean;
  borderTop?: boolean;
}

export const DialogFooter: React.FC<DialogFooterProps> = ({
  children,
  centered = true,
  borderTop = true,
}) => {
  if (!children) {
    return (
      <div
        style={{
          padding: '16px 24px 20px 24px',
          textAlign: centered ? 'center' : 'left',
          borderTop: borderTop ? '1px solid #F3F4F6' : 'none',
        }}
      >
        <span
          style={{
            color: 'var(--color-charcoal, #63615C)',
            fontFamily: 'Interstate',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '0.6px',
          }}
        >
          You can now safely close this window
        </span>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '24px',
        textAlign: centered ? 'center' : 'left',
        borderTop: borderTop ? '1px solid #F3F4F6' : 'none',
      }}
    >
      {children}
    </div>
  );
};
